<forge-menu *ngIf="loaded" placement="bottom" [options]="helpOptions" [highlightFirst]="false"
            (forge-menu-select)="itemSelected($event)" (forge-menu-open)="menuOpened($event)">
    <forge-icon-button tabindex="0" class="tyl-icon-button" aria-label="Help menu">
        <forge-tooltip placement="bottom">Help</forge-tooltip>
        <forge-icon name="help" style="--forge-icon-color: var(--_app-bar-foreground);"></forge-icon>
    </forge-icon-button>
</forge-menu>
